import { render, staticRenderFns } from "./DroppedOrderBannerWrapper.vue?vue&type=template&id=1558cee6&lang=pug"
import script from "./DroppedOrderBannerWrapper.vue?vue&type=script&lang=ts"
export * from "./DroppedOrderBannerWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports